module.exports = __webpack_public_path__ + "static/media/KZ.9a60e437.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/KZ.svg
// module id = 2192
// module chunks = 7